import { useState, useCallback, useRef } from 'react';

export function useTempleData() {
  const [stateData, setStateData] = useState(null);
  const [loading, setLoading]     = useState(false);
  const [error, setError]         = useState(null);
  const cache                     = useRef({});

  const loadState = useCallback(async (stateId, filename) => {
    if (cache.current[stateId]) {
      setStateData(cache.current[stateId]);
      setError(null);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const res = await fetch(`${process.env.PUBLIC_URL}/data/${filename}`);
      if (!res.ok) throw new Error(`Failed to load ${filename} (${res.status})`);
      const json = await res.json();
      const data = Array.isArray(json) ? json : json.temples;
      cache.current[stateId] = data;
      setStateData(data);
    } catch (err) {
      setError(err.message);
      setStateData(null);
    } finally {
      setLoading(false);
    }
  }, []);

  const clearState = useCallback(() => { setStateData(null); setError(null); }, []);

  return { stateData, loading, error, loadState, clearState };
}
